export const countryOptions = [
  { label: "BRA", value: "BRA", ddi: "55" },
  { label: "USA", value: "USA", ddi: "1" },
  { label: "CAN", value: "CAN", ddi: "1" },
  { label: "MEX", value: "MEX", ddi: "52" },
  { label: "ARG", value: "ARG", ddi: "54" },
  { label: "CHL", value: "CHL", ddi: "56" },
  { label: "COL", value: "COL", ddi: "57" },
  { label: "PER", value: "PER", ddi: "51" },
  { label: "VEN", value: "VEN", ddi: "58" },
  { label: "URY", value: "URY", ddi: "598" },
  { label: "PRY", value: "PRY", ddi: "595" },
  { label: "BOL", value: "BOL", ddi: "591" },
  { label: "ECU", value: "ECU", ddi: "593" },
  { label: "GBR", value: "GBR", ddi: "44" },
  { label: "ESP", value: "ESP", ddi: "34" },
  { label: "FRA", value: "FRA", ddi: "33" },
  { label: "ITA", value: "ITA", ddi: "39" },
  { label: "DEU", value: "DEU", ddi: "49" },
  { label: "PRT", value: "PRT", ddi: "351" },
  { label: "NLD", value: "NLD", ddi: "31" },
  { label: "BEL", value: "BEL", ddi: "32" },
  { label: "SWE", value: "SWE", ddi: "46" },
  { label: "CHE", value: "CHE", ddi: "41" },
  { label: "AUT", value: "AUT", ddi: "43" },
  { label: "NOR", value: "NOR", ddi: "47" },
  { label: "FIN", value: "FIN", ddi: "358" },
  { label: "DNK", value: "DNK", ddi: "45" },
  { label: "JPN", value: "JPN", ddi: "81" },
  { label: "CHN", value: "CHN", ddi: "86" },
  { label: "KOR", value: "KOR", ddi: "82" },
  { label: "IND", value: "IND", ddi: "91" },
  { label: "RUS", value: "RUS", ddi: "7" },
  { label: "SAU", value: "SAU", ddi: "966" },
  { label: "ARE", value: "ARE", ddi: "971" },
  { label: "ISR", value: "ISR", ddi: "972" },
  { label: "ZAF", value: "ZAF", ddi: "27" },
  { label: "AUS", value: "AUS", ddi: "61" },
  { label: "NZL", value: "NZL", ddi: "64" },
  { label: "TUR", value: "TUR", ddi: "90" },
];
